/**
 * Bind toggle listeners for every dropdown inside the given root.
 *
 * @param {Document | Element} root - The root to search for dropdown toggles.
 * @returns {void}
 */
export function initLuxDropdowns(root) {
    const luxDropdownToggles = root.querySelectorAll(
        "*[data-toggle='lux-dropdown'] .lux-dropdown-btn",
    );

    luxDropdownToggles.forEach(function (toggle) {
        const dropdownWrapper = toggle.closest(".lux-dropdown-wrapper");
        if (!dropdownWrapper) return;

        toggle.addEventListener("click", function (e) {
            e.stopPropagation();
            dropdownWrapper
                .querySelector(".lux-dropdown-wrapper.active")
                ?.classList.remove("active");
            dropdownWrapper.classList.toggle("active");
        });
    });
}

initLuxDropdowns(document);

document.addEventListener("click", function (e) {
    const activeDropdown = document.querySelector(
        ".lux-dropdown-wrapper.active .lux-dropdown-content",
    );

    if (
        !activeDropdown ||
        !(e.target instanceof Node) ||
        !activeDropdown.contains(e.target)
    ) {
        document
            .querySelectorAll(".lux-dropdown-wrapper.active")
            .forEach(function (wrapper) {
                wrapper.classList.remove("active");
            });
    }
});
